import React, { useEffect, useState } from "react";
import { Avatar, Box, Breadcrumbs, Card, CardContent, Chip, Divider, Typography, useTheme } from "@mui/material";
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, timelineOppositeContentClasses, TimelineSeparator } from "@mui/lab";
import { FaArrowRight } from "react-icons/fa6";
import moment from "moment";
import { useGetHistoryQuery } from "store/slices/apis/workflowSlice";

const HistoryTimeLine = (props) => {
    const { id, workflow } = props
    const [workflowStatus, setWorkflowStatus] = useState('N/A');
    const theme = useTheme();
    const historyRes = useGetHistoryQuery({ id: id });

    useEffect(() => {
        if (historyRes?.isSuccess) {
            if (historyRes?.data?.data?.length > 0) {
                let documentDetail = historyRes?.data?.data[0];
                if (documentDetail) {
                    workflow(documentDetail?.previousStatus ?? 'N/A');
                }
            }
        }
    }, [historyRes?.isSuccess])

    return (
        <>
            <Card sx={{ borderRadius: 1, boxShadow: 'none', p: 3, pt: 1.5, minHeight: '250px' }}>
                <Box sx={{ width: '100%', mb: 1.5 }}>
                    <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '500', color: '#252525', lineHeight: "32px", letterSpacing: '-0.4px' }}>
                        History
                    </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />
                <CardContent sx={{ p: 0 }}>
                    {historyRes?.data?.data?.length > 0 ?
                        <Timeline
                            sx={{
                                [`& .${timelineOppositeContentClasses.root}`]: {
                                    flex: 0.2,
                                    display: { xs: "none", sm: "block" } // hide on mobile, show on tablet+
                                },
                                overflow: "auto",
                            }}
                        >
                            {historyRes?.data?.data?.map((val, index) => (
                                <TimelineItem key={index}>
                                    <TimelineOppositeContent
                                        sx={{
                                            m: "auto 0",
                                            display: { xs: "none", sm: "block" }, // responsive
                                        }}
                                        align="right"
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        {moment(val?.createdDate).format("MMMM D, YYYY [at] hh:mm A")}
                                    </TimelineOppositeContent>

                                    <TimelineSeparator>
                                        <TimelineConnector />
                                        <TimelineDot
                                            sx={{
                                                padding: "0px",
                                                boxShadow: "none",
                                                margin: "6.5px 0px",
                                                borderStyle: "none",
                                                backgroundColor: "inherit",
                                            }}
                                        >
                                            <Avatar sx={{ bgcolor: theme?.customSettings?.themeColor }}>{`${val?.userName?.split(' ')[0][0]}`}</Avatar>
                                        </TimelineDot>
                                        <TimelineConnector />
                                    </TimelineSeparator>

                                    <TimelineContent sx={{ py: "12px", px: 2 }}>
                                        <Typography
                                            variant="h6"
                                            component="span"
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: "16px",
                                            }}
                                        >
                                            {val?.userName}
                                        </Typography>

                                        {/* On mobile, show date above */}
                                        <Typography
                                            sx={{
                                                fontSize: "12px",
                                                color: "text.secondary",
                                                display: { xs: "block", sm: "none" },
                                            }}
                                        >
                                            {moment(val?.createdDate).format("MMM D, YYYY hh:mm A")}
                                        </Typography>

                                        {val?.previousStatus && (
                                            <Breadcrumbs
                                                separator={<FaArrowRight fontSize="small" />}
                                                aria-label="status transition"
                                            >
                                                <Chip
                                                    label={val?.previousStatus}
                                                    variant="outlined"
                                                    sx={{
                                                        fontWeight: "bold",
                                                        borderColor: "#1976d2",
                                                        color: "#212121",
                                                        borderRadius: "4px",
                                                        height: "20px",
                                                    }}
                                                />
                                            </Breadcrumbs>
                                        )}

                                        <Typography sx={{ fontSize: "14px" }}>{val?.comment}</Typography>
                                    </TimelineContent>
                                </TimelineItem>
                            ))}
                        </Timeline>


                        : <Typography variant="caption" sx={{ textAlign: 'center' }}>

                            Record not found.
                        </Typography>
                    }

                </CardContent>
            </Card>
        </>
    );
}

export default HistoryTimeLine;
